export default __webpack_public_path__ + "static/media/convertise-negative.8467e5ce.svg";